import { Device } from '@capacitor/device';

export const logDeviceInfo = async () => {
  return Device.getInfo();
};
